import { AccordionDetails, Box, Typography } from "@mui/material";
import React from "react";
import { BriaFaqSectionProps, FaqAnswer } from "./faq";
import BriaAccordion from "../BriaAccordion/BriaAccordion";
import styles from "./BriaFaqSection.module.scss";

const BriaFaqSection: React.FC<BriaFaqSectionProps> = ({ title, faqItems, onLinkClick, onAnswerClick, className, titleClassName }) => {
	const handleAnswerLinkClick = (id: string) => {
		if (onLinkClick) {
			onLinkClick(id);
		}
	};

	const renderAnswerContent = (answer: FaqAnswer[]) => {
		return answer.map((ans, i) => {
			switch (ans.type) {
				case "text":
				case "paragraph":
					return (
						<Typography 
							key={i} 
							className={styles.accordionDetails}
							dangerouslySetInnerHTML={{ __html: ans.content }}
							onClick={onAnswerClick}
						/>
					);

				case "paragraphWithListAndLink":
					return (
						<React.Fragment key={i}>
							<Typography 
								className={styles.accordionDetails}
								dangerouslySetInnerHTML={{ __html: ans.intro }}
							/>
							{ans.list && (
								<ul className={styles.serviceList}>
									{ans.list.map((li, j) => (
										<li 
											key={j} 
											className={styles.serviceListItem}
											dangerouslySetInnerHTML={{ __html: li }}
										/>
									))}
								</ul>
							)}
							{ans.midText && (
								<Typography 
									className={styles.accordionDetails}
									dangerouslySetInnerHTML={{ __html: ans.midText }}
								/>
							)}
							{ans.linkText && ans.linkId && ans.outro && (
								<Typography className={styles.accordionDetails}>
									<Typography
										component="a"
										onClick={() => handleAnswerLinkClick(ans.linkId ?? "")}
										className={styles.linkUrl}
									>
										{ans.linkText}
									</Typography>
									{" " + ans.outro}
								</Typography>
							)}
						</React.Fragment>
					);

				default:
					return null;
			}
		});
	};

	return (
		<Box className={`${styles.faqSection} ${className || ""}`}>
			<Typography className={`${styles.faqTitle} ${titleClassName || ""}`}>{title}</Typography>

			{faqItems.map((item, index) => (
				<BriaAccordion
					key={index}
					className={styles.accordion}
					accordionTitle={item.question}
					useSecondaryIcons
				>
					<AccordionDetails>{renderAnswerContent(item.answer)}</AccordionDetails>
				</BriaAccordion>
			))}
		</Box>
	);
};

export default BriaFaqSection;
